import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';

// config
import { app } from '../../../../../config/app.config';

// services
import { AuthService, NavigationService } from '@sideline/sideline-apps-shared';

//components
import { PublicBranding } from '../../../../layouts/public/components/public-branding/public-branding';
import { PublicContent } from '../../../../layouts/public/components/public-content/public-content';

@Component({
  selector: 'app-not-found-content',
  templateUrl: './not-found-content.html',
  styleUrl: './not-found-content.scss',
  standalone: true,
  imports: [
    ButtonModule,
    PublicBranding,
    PublicContent,
  ],
})
export class NotFoundContent {
  title = app.marketing.names.product;

  private authService = inject(AuthService);
  private navService = inject(NavigationService);

  navigateHome(): void {
    if (this.authService.isAuthenticated()) {
      this.navService.landingPrivate();
    } else {
      this.navService.landingPublic();
    }
  }

  navigateBack(): void {
    this.navService.back();
  }
}
